const environment = ENVIRONMENT === 'development' ? 'test' : ENVIRONMENT;

export interface PagePerformanceReportData {
  user_defined_first_paint: number;
  user_defined_first_interactive: number;
  user_defined_first_api: number;

  first_paint: number;
  first_contentful_paint: number;

  ttfb: number;
  response_end: number;
  dom_loading: number;
  dom_interactive: number;
  dom_content_loaded_event_end: number;
  dom_complete: number;

  redirect: number;
  app_cache: number;
  dns: number;
  tcp: number;
  stalled: number;
}
interface MDAPConfigValue {
  appName: string;
  pagePointIds: { [key in keyof PagePerformanceReportData]: string };
  pvPointId: string;
}

const configs: { [key in typeof environment]: MDAPConfigValue } = {
  test: {
    appName: 'web-chatbot-test',
    pagePointIds: {
      user_defined_first_paint: '6df260a113065aee1014a1c32192c7ff',
      user_defined_first_interactive: '27d6cda07276195098c9d1a43ab52543',
      user_defined_first_api: 'b1275c7147cd2c085947a524ccff6ec8',
      first_paint: 'd8384f5ddc21435711b0d8563bd371ba',
      first_contentful_paint: 'bcd54c8a3b795b6e960ae485adb60ced',
      ttfb: '03d54ccc7e6ed4ffd4e65cc9c4ca84f8',
      response_end: '4a21293d2b59ff6b1371f3cd6aa10302',
      dom_loading: '56aa68711e988189aca035b339a36965',
      dom_interactive: '1d8f78de8bf1a1fb5ae71a8dbec13258',
      dom_content_loaded_event_end: '876d01f0bf54376190b63b6da324b237',
      dom_complete: '144b6469cb1fcf81e53b22ed5843bc5c',
      redirect: 'fd7d602cb7774718d73c7733d632bfc3',
      app_cache: '64d2b855ba3cea15568e2d5bacac914b',
      dns: 'd69a99705f26b8e44b3264677cd642da',
      tcp: '064ed803c066f60d694b11aa87bd63c2',
      stalled: '3dacefd5ad764d8dd192d2cba1ffe0e3',
    },
    pvPointId: '5c7243c4ebf632ffc9b4baff8ac96c4a',
  },
  live: {
    appName: 'web-chatbot',
    pagePointIds: {
      user_defined_first_paint: '563ef21630b43d23d61dfaef5ef756f7',
      user_defined_first_interactive: '86e32de1080a60c9055b311ff953ab7b',
      user_defined_first_api: 'b024742cb968fd4775c5cae5179cd31d',
      first_paint: 'e1f086c46784ea74d910c33e1c620894',
      first_contentful_paint: '3b5b8f926893fdef608fb1613058b643',
      ttfb: '3a2ffeac22e813aaadc4a8fe58391043',
      response_end: '3abf8a97de68296b8c995173621759ee',
      dom_loading: 'c69c91e4dcab349e1ade8e51785e5109',
      dom_interactive: '5b0dfa349bd923ec5e7d66fd593115d6',
      dom_content_loaded_event_end: 'ef36dcbb2aca6238594ca2f9b46e3751',
      dom_complete: '62acfd898ec5bacd2b339561a9299e15',
      redirect: '37cda5cc014dbb3242d25d625709a7dc',
      app_cache: 'c9ec3970bc2cf4d3b1f8bb32396dc4c3',
      dns: '8e7459e2ed19bce083146374824dc514',
      tcp: '94ef5d2622e09e1ef2d1a7acf18b2947',
      stalled: 'c765443466652aa6506533338f37d2ca',
    },
    pvPointId: '6460c0757819d0a708c08d9092211fa1',
  },
};

export const config = environment === 'live' ? configs.live : configs.test;
